import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';

import { Consolidation } from '@futrli-sdk/consolidations';
import { useModal } from '@futrli/shared-services';

import { DeleteConsolidationDialog } from '../../dialogs/delete-consolidation-dialog/delete-consolidation-dialog';

interface ConsolidationsActionsContextValue {
  handleDeleteConsolidationClick: (consolidation: Consolidation) => void;
}

const ConsolidationsActionsContext = createContext<ConsolidationsActionsContextValue>(
  ({} as unknown) as ConsolidationsActionsContextValue
);

export const ConsolidationsActionsProvider = ({ children }: { children: ReactNode }) => {
  const deleteConsolidationDialog = useModal();
  const [consolidation, setConsolidation] = useState<Consolidation>();

  const handleDeleteConsolidationClick = useCallback(
    (consolidation: Consolidation) => {
      setConsolidation(consolidation);
      deleteConsolidationDialog.open();
    },
    [deleteConsolidationDialog]
  );

  const value = {
    handleDeleteConsolidationClick
  };

  return (
    <ConsolidationsActionsContext.Provider value={value}>
      {consolidation && deleteConsolidationDialog.isOpen && (
        <DeleteConsolidationDialog
          consolidationId={consolidation.id}
          isOpen={deleteConsolidationDialog.isOpen}
          onClose={deleteConsolidationDialog.close}
          workspaceId={consolidation.workspace_id}
        />
      )}

      {children}
    </ConsolidationsActionsContext.Provider>
  );
};

export const useConsolidationsActions = () => {
  const context = useContext(ConsolidationsActionsContext);
  if (!context) {
    throw new Error('useConsolidationsActions must be used within a ConsolidationsActionsProvider');
  }
  return context;
};
